




























































































































































































































































































































import Vue from 'vue';
import Tabs from "@/components/Tabs.vue";
import store, { PreAccountingStore } from "../services/PreAccountingStore";
import { PreAccEditDimension, PreAccEditDimensionDefaultProps, PreAccEditItem } from '../models/PreAccEditing';
import BasicGridDimensionWrapper from './BasicGridDimensionWrapper.vue';
import LookupComboBox from "@/components/LookupComboBox.vue";
import { t } from "@/plugins/i18n";

const ROMAN = ["IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];

const baseColumns = [
      {
        field: "id",
        title: " ",
        cell: 'command',
        width: "100px"
      },
      {
        field: "dimCode",
        title: t("DimenzioKod"),
        cell: "dimCodeName",
      },
      {
        field: "total",
        title: t("Osszeg"),
        cell: "totalTemplate",
      },
];
const endColumns = [
    {
      width: "0px",
      filterable: false,
    },
];


interface Data {
  store: PreAccountingStore;
}

interface Methods {
  preSetItems(e: any): void;
  onRowClick(item: any): void;
  confirmDelete(item: PreAccEditDimension): void;
  setDimCodeType(num: number): void;
  setDefaultSelectedValues(num: number): void;
  tabEnabled(type: number): boolean;
  onSelectedProjectUpdate(value: any, item: PreAccEditDimension): void;
  onSelectedPoUpdate(value: any, item: PreAccEditDimension): void;
  onValueChanged(item: PreAccEditDimension): void;
  onCarValueChanged(item: PreAccEditDimension, newValue: any): void;
  onStationValueChanged(item: PreAccEditDimension, newVal: any): void;
  onUserValueChanged(item: PreAccEditDimension, newVal: any): void;
  onToolValueChanged(item: PreAccEditDimension, newVal: any): void;
  productions(projectID: number): object[];
  checkChange(item: any, codeField: string, idField: string, nameField: string): void;
  handleChange(item: PreAccEditDimension, codeField: string, idField: string, nameField: string): void;
}
interface Computed {
  dimTabs: { type: number; label: string }[];
  dim4columns: any;
  dim5columns: any;
  dim6columns: any;
  dim7columns: any;
  dim8columns: any;
  dim9columns: any;
  dim10columns: any;
  dim11columns: any;
  dim12columns: any;
  positiveNegativeItem: PreAccEditItem;
  positiveNegativeDimensionCodeType: number;
  positiveNegativeDimension: PreAccEditDimension;
  activeDimensions: PreAccEditDimension[];
}

interface Props {
  positiveNegative: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  mounted() {
    this.$emit('register-focus', [this.$refs.newDim])
  },
  props: {
    positiveNegative: {type: String},
  },

  components: {
    Tabs,
    BasicGridDimensionWrapper,
    LookupComboBox,
  },

  data() {
    return {
      store,
    }
  },


  methods: {
    preSetItems(e: any) {
      const type = e.currentTarget.dataset.type;
      this.setDimCodeType(Number(type));
    },
    onRowClick(item){
      store.selectedDimension = item.dataItem;
      this.positiveNegativeDimension = item.dataItem
    },
    confirmDelete(item){
      this.$emit('deleteDimItem',item);
    },
    setDimCodeType(num){
      this.positiveNegativeDimensionCodeType = num;
    },
    setDefaultSelectedValues(num){
      const array = this.store.dimensionsRows.filter(x => x.head == this.positiveNegativeItem.id && x.dimCodeType == num);
      if(array.length > 0){
        this.positiveNegativeDimension = array[0];
      }
      else{
        this.positiveNegativeDimension = {...PreAccEditDimensionDefaultProps};
      }
    },
    // K2D fül-láthatóság: külső főkönyvnél (gb_ext_book) a csaccdimcodetype élőség
    // típusonként; egyébként a gb_dim_4_9 kapcsol mindent (a panel elrejtését a szülő végzi)
    tabEnabled(type){
      if(this.store.flags.extBook){
        return this.store.flags.dimTypeLive[type] !== false;
      }
      return true;
    },
    onSelectedProjectUpdate(val,item){
      item.project = val.id;
      item.projectMainCode = val.mainCode;
      item.projectName = val.name;
      item.projectCode = val.code;
      item.poId = 1;
      item.poNumber = "-";
      item.workNumber = "-";
    },
    onSelectedPoUpdate(val,item){
      if(val as object){
        item.poId = val.id;
        item.poNumber = val.poNumber;
        item.workNumber = val.workNumber;
      }
    },
    productions(projectID){
      if(projectID === 1)
        return this.store.pos;

      return this.store.pos.filter((i: any) => i.project == projectID)
    },
    onValueChanged(item){
      const ogItem = store.originalDimensionsRows.find(x => x.id === item.id)
      if(!ogItem)
          return

      const fieldsToCheck: (keyof PreAccEditDimension)[] = ['extProdParts','productParts','partsId','carId','extProdPartner','project','poId','userId','stationId','toolId']
      for (const key of fieldsToCheck) {
          if(item[key] != ogItem[key]){
            const exists = this.store.modifiedDimensions.some(x => x.id === item.id);
            if (!exists) {
                this.store.modifiedDimensions.push(item);
            }
            return
          }
      }

      this.store.modifiedDimensions = this.store.modifiedDimensions.filter(x=> x.id !== item.id)
    },
    onCarValueChanged(item, newVal){
      item.carId = newVal.id,
      item.regNum = newVal.reqNum
    },
    // VIII. dimenzió: a három választó (munkaállomás / munkatárs / szerszám) kizárja
    // egymást — K2D: a másik két mező '-' / 1-re áll. A törlés (x) null-t ad: akkor a
    // saját mező is 1 / "-" lesz.
    onStationValueChanged(item, newVal){
      item.stationName = newVal ? newVal.name : "-"
      item.stationId = newVal ? newVal.id : 1

      item.userName = item.toolName = "-"
      item.userId = item.toolId = 1
    },
    onUserValueChanged(item,newVal){
      item.userName = newVal ? newVal.name : "-"
      item.userId = newVal ? newVal.id : 1

      item.stationName = item.toolName = "-"
      item.stationId = item.toolId = 1
    },
    onToolValueChanged(item,newVal){
      item.toolName = newVal ? newVal.name : "-"
      item.toolId = newVal ? newVal.id : 1

      item.stationName = item.userName = "-"
      item.stationId = item.userId = 1
    },
    async checkChange(item, codeField, idField, nameField) {
      if (!item[codeField]) {
        item[idField] = 1;
        nameField != "" ? item[nameField] = "-" : nameField;
        return;
      }
      let isValid: any;
      if(nameField != ""){
        isValid = await this.store.isValidPartCode(item[codeField]);
      }
      else{
        isValid =  await this.store.ValidPartnerName(item[codeField])
      }

      if (isValid.id > 1) {
        item[idField] = isValid.id;
        nameField != "" ? item[nameField] = isValid.name : nameField;
      } else {
        item[idField] = 1;
        nameField != "" ? item[nameField] = "-" : nameField;
      }
    },
    async handleChange(item, codeField, idField, nameField){
      try {
        await this.checkChange(item, codeField,idField,nameField);
        this.onValueChanged(item);
      } catch (err) {
        console.error(err);
      }
    },
  },


  computed: {
    dimTabs() {
      // K2D-paritás: csaccdimcodetype 5 = IV. dim ... 13 = XII. dim
      return ROMAN.map((label, i) => ({ type: i + 5, label: t("GeneralLedger_Dimenzio", [label]) }));
    },
    dim4columns: () =>[
      ...baseColumns,
      ...endColumns
    ],
    // Fülenkénti kísérő oszlopok: a K2D d_g_accitem_d_new láthatóság-térképe
    // (a Ticket 1-es olvasó nézettel azonos mezőkészlet), DLMP471-es szerkesztő cellákkal
    dim5columns: () =>[
      ...baseColumns,
      {
        field: "extProdParts",
        title: t("SelejtCikk")
      },
      {
        field: "extProdPartsCode",
        title: t("Cikkszam"),
        cell: "partsCode"
      },
      {
        field: "extProdPartsName",
        title: t("Megnevezes"),
      },
      ...endColumns
    ],
    dim6columns: () => [
      ...baseColumns,
      {
        field: "partsCode",
        title: t("Cikkszam"),
        cell: "ownPartsCode"
      },
      {
        field: "partsName",
        title: t("PreAccounting_CikkMegnevezese")
      },
      {
        field: "productParts",
        title: t("GyartottTermek")
      },
      {
        field: "productPartsCode",
        title: t("Cikkszam"),
        cell: "partsCode"
      },
      {
        field: "productPartsName",
        title: t("Megnevezes")
      },
      {
        field: "production",
        title: t("GyartasInformacio")
      },
      {
        field: "stock",
        title: t("Keszlet")
      },
      ...endColumns
    ],
    dim7columns: () => [
      ...baseColumns,
      {
        field: "carId",
        title: t("Gepjarmu"),
        cell: "car"
      },
      {
        field: "regNum",
        title: t("Rendszam"),
        cell: "regNum"
      },
      ...endColumns

    ],
    dim8columns: () => [
      ...baseColumns,
      {
        field: "userName",
        title: t("Munkatars"),
        cell: "userName"
      },
      {
        field: "stationName",
        title: t("Munkaallomas"),
        cell: "stationName"
      },
      {
        field: "toolName",
        title: t("Szerszam"),
        cell: "toolName"
      },
      ...endColumns
    ],
    dim9columns: () => [
      ...baseColumns,
      {
        field: "project",
        title: t("Projekt"),
        cell: "projectID"
      },
      {
        field: "projectName",
        title: t("ProjektNeve")
      },
      {
        field: "poId",
        title: t("Megrendeles"),
        cell: "poId"
      },
      {
        field: "poNumber",
        title: t("MegrendelesSzam")
      },
      {
        field: "workNumber",
        title: t("Munkaszam")
      },
      ...endColumns
    ],
    dim10columns: () => [
      ...baseColumns,
      {
        field: "extProdPartner",
        title: t("KiegeszitoPartner")
      },
      {
        field: "extProdPartnerName",
        title: t("PartnerNeve"),
        cell: "extProdPartnerName"
      },
      ...endColumns

    ],
    dim11columns: () => [
      ...baseColumns,
      ...endColumns

    ],
    dim12columns: () => [
      ...baseColumns,
      ...endColumns

    ],
    positiveNegativeItem(){
      return this.$props.positiveNegative == "positive" ? this.store.positiveSelectedItem : this.store.negativeSelectedItem;
    },
    positiveNegativeDimension:{
      get() {
        return this.$props.positiveNegative == "positive" ? this.store.positiveSelectedDimension : this.store.negativeSelectedDimension;
      },
      set(newVal) {
        if (this.$props.positiveNegative === "positive") {
          this.store.positiveSelectedDimension = newVal;
        } else {
          this.store.negativeSelectedDimension = newVal;
        }
      }
    },
    positiveNegativeDimensionCodeType: {
      get() {
      return this.$props.positiveNegative == "positive" ? this.store.positiveSelectedDimCodeType : this.store.negativeSelectedDimCodeType;
      },
      set(newVal) {
        if (this.$props.positiveNegative === "positive") {
          this.store.positiveSelectedDimCodeType = newVal;
        } else {
          this.store.negativeSelectedDimCodeType = newVal;
        }
      }
    },
    activeDimensions(){
      // Az új (negatív id-jú) tételek bontás-sorai a head negatív temp id-ján keresztül
      // kötődnek (K2D il_accitem_id minta); a head == 0 ág a tétel newDimensions listája.
      return store.dimensionsRows.filter((x) =>
      x.dimCodeType == this.positiveNegativeDimensionCodeType &&
      (
        x.head != 0
        ? x.head == this.positiveNegativeItem.id
        : this.positiveNegativeItem.newDimensions.includes(x) )
      )
      .map(item =>
        {
          item.selected = item === this.store.selectedDimension;
          item.inEdit = item === this.store.selectedDimension;
          return item;
        }
      );
    }
  },
  watch:{
    activeDimensions:{
      handler(newVal,oldVal) {
        if(newVal[0] != oldVal[0]){
          this.setDefaultSelectedValues(this.positiveNegativeDimensionCodeType);
        }
      },deep: true
    },
    positiveNegativeItem(){
      // K2D retrieveend: a legkisebb LÉTEZŐ dimcodetype lesz az aktív fül;
      // ha a tételnek nincs bontása, az első engedélyezett fülre ugrunk.
      const item = this.positiveNegativeItem;
      const existing = this.store.dimensionsRows
        .filter(x => x.head == item.id)
        .map(x => x.dimCodeType)
        .sort((a, b) => a - b);
      let type = existing.length > 0 ? existing[0] : 0;
      if (type < 5 || type > 13) {
        const firstEnabled = this.dimTabs.find(t => this.tabEnabled(t.type));
        type = firstEnabled ? firstEnabled.type : 5;
      }
      this.setDimCodeType(type);
      (this.$refs.tab as any).setTab(type - 5);
    }
  }
})
